module.exports = __webpack_public_path__ + "4da0a71f3674d3efbc975e076802e494.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/bb-cream/bb-cream-nude.jpg
 ** module id = 129
 ** module chunks = 0
 **/